var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGloabalMarket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "#FFF3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.95 24.5H26.1667C25.7246 24.5 25.3007 24.6756 24.9882 24.9882C24.6756 25.3007 24.5 25.7246 24.5 26.1667V29.95",
    stroke: "#E65100",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 14.7833V16.1667C17.8333 16.8297 18.0966 17.4656 18.5655 17.9344C19.0343 18.4033 19.6702 18.6667 20.3333 18.6667C20.7753 18.6667 21.1992 18.8423 21.5118 19.1548C21.8243 19.4674 21.9999 19.8913 21.9999 20.3333C21.9999 21.25 22.7499 22 23.6666 22C24.1086 22 24.5325 21.8244 24.8451 21.5118C25.1577 21.1993 25.3333 20.7754 25.3333 20.3333C25.3333 19.4167 26.0833 18.6667 26.9999 18.6667H29.6416",
    stroke: "#E65100",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1666 30.2916V27C21.1666 26.5579 20.991 26.134 20.6784 25.8214C20.3659 25.5089 19.9419 25.3333 19.4999 25.3333C19.0579 25.3333 18.634 25.1577 18.3214 24.8451C18.0088 24.5326 17.8333 24.1087 17.8333 23.6666V22.8333C17.8333 22.3913 17.6577 21.9673 17.3451 21.6548C17.0325 21.3422 16.6086 21.1666 16.1666 21.1666H13.7083",
    stroke: "#E65100",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 30.3333C26.6025 30.3333 30.3334 26.6023 30.3334 22C30.3334 17.3976 26.6025 13.6666 22.0001 13.6666C17.3977 13.6666 13.6667 17.3976 13.6667 22C13.6667 26.6023 17.3977 30.3333 22.0001 30.3333Z",
    stroke: "#E65100",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGloabalMarket);
export default __webpack_public_path__ + "static/media/gloabalMarket.a1f30e50e5b875962d0f3390dca850ea.svg";
export { ForwardRef as ReactComponent };